import React, { useState, useEffect } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import { FaRegEye } from "react-icons/fa6";
import { AiOutlinePrinter } from "react-icons/ai";
import { clearRows } from "../../../Redux/actions/rowActions";
import { ClipLoader } from "react-spinners";
import { useDispatch, useSelector } from "react-redux";
import "../pagination/pagination.css";
import { IoAddSharp } from "react-icons/io5";
import Pagination from "../pagination/pagination";
import { GrEdit } from "react-icons/gr";
import { MdOutlineDeleteOutline, MdOutlineAutorenew } from "react-icons/md";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { getName, getUserName } from "../../../Redux/selecters";
import { toast } from "react-toastify";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import Modal from 'react-bootstrap/Modal';
const LeaseListing = () => {
  const REPORT_URL = process.env.REACT_APP_REPORTS_URL
  const [rowData, setRowData] = useState([]);
  const [proprtyList, setProperty] = useState([]);
  const [loader, setloader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedtem, setSelectedItem] = useState(null);
  const apiService = new LeaseApiService();
  const userName = useSelector(getName);
  const [FilterTab, setFilterTab] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [previewModal, setPreviewModal] = useState(false);
  const [renew, setRenewpopup] = useState(false);
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const location = useLocation();
  const StatusFilter = [
    { value: "All", label: "All" },
    { value: "0", label: "Active" },
    { value: "1", label: "Renewed" },
    { value: "2", label: "Terminated" },
  ]
  const [formData, setFormData] = useState({
    email: "",
    Proprty: [{ label: "Select Property", value: "" }],
    Status: [{ label: "All", value: "" }],
    Unit: [{ label: "Select Unit", value: "" }],
    LeaseNo: [{ label: "Select Lease No", value: "" }],
  })
  useEffect(() => {
    const storedPermissions =
      JSON.parse(localStorage.getItem("RoleAccess")) || [];
    const permissions = storedPermissions?.filter(
      (acc) => acc.formName === "Purchase Requisition"
    );
    setPermissions(permissions[0]);
  }, [])
  useEffect(() => {
    getItems();
  }, [])
  useEffect(() => {
    fetchDropdownData();
  }, [])
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("dropdownTypes", "LASerPropertyName");
      const res = await apiService.getApiParamater(
        "GET_PROPERT_DROP",
        `?${params.toString()}`
      );
      setProperty(res?.data?.dropdowns?.LASerPropertyName);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }
  const handleEdit = async () => {

    if (selectedRow?.leaseNo) {
      try {

        const validation = new URLSearchParams();
        validation.append("Action", "checkLeaseEditValidation");
        validation.append("RecordId", selectedRow?.recordId);
        ;
        const validRes = await apiService.getApiParamater(
          "GET_UNITNO_DATA",
          `?${validation.toString()}`
        );
        let valisdlist = validRes?.data?.result?.data;
        // const leasoNolist = validRes?.data?.result?.data?.find(item => !item.Invoices );
        if (
          validRes?.data?.result?.data?.Invoices === 0 &&
          validRes?.data?.result?.data?.Receipts === 0
        ) {
          navigate(
            `/Property/Management/LeaseAgreement/edit/${selectedRow?.leaseNo}`,
            { state: selectedRow }
          );
        } else if (
          validRes?.data?.result?.data?.Invoices > 0 ||
          validRes?.data?.result?.data?.Receipts > 0
        ) {
          toast.warning(
            `Invoices OR Receipts are created for this lease Aggrement (${selectedRow?.leaseNo}) Cannot be Edited`
          );
        } else if (validRes?.data?.result?.data?.length === 0) {
          toast.warning("Please refresh the page");
        }
      } catch (error) {
        console.error("Error Save Data", error?.deleteRes?.data?.message);
      }
    }
  }
  const handleRenew = async () => {
    if (selectedRow?.leaseNo && selectedRow?.status === "Active") {
      try {
        const validation = new URLSearchParams();
        validation.append("Action", "checkAmountReceivedForLeaseRenew");
        validation.append("LeaseNo", selectedRow?.leaseNo);
        const validRes = await apiService.getApiParamater(
          "GET_UNITNO_DATA",
          `?${validation.toString()}`
        );
        let valisdlist = validRes?.data?.result?.data;
        const totalAmount = valisdlist?.reduce((sum, row) => sum + (row.Balance || 0), 0);
        if (totalAmount > 0) {
          setRenewpopup(true)
        } else {
          navigate(
            `/Property/Management/LeaseAgreement/renew/${selectedRow?.leaseNo}`,
            { state: selectedRow }
          )
        }
      } catch (error) {
        console.error("Error Save Data", error?.deleteRes?.data?.message);
      }

    } else {
      toast.warning("You cannot renew this Lease Agreement")
    }
  }
  const handleRenewshift = () => {
    if (selectedRow?.leaseNo && selectedRow?.status === "Active") {
      navigate(`/Property/Management/LeaseAgreement/renew/${selectedRow?.leaseNo}`, { state: selectedRow })
    } else {
      toast.warning("You cannot renew this Lease Agreement")
    }
  }
  const handlePrint = () => {
    if (selectedRow?.leaseNo) {
      const token = localStorage.getItem("Token");
      const DB = localStorage.getItem("DataBase");
      if (!token) {
        alert("Auth token is missing! Unable to proceed.");
        return;
      }
      const popupWidth = 1000;
      const popupHeight = 600;
      const popupLeft = (window.screen.width - popupWidth) / 2;
      const popupTop = (window.screen.height - popupHeight) / 2;
      const popup = window.open(
        "",
        "ReportPopup",
        `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
      );

      if (popup) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = REPORT_URL;
        form.target = "ReportPopup";

        const inputs = [
          { name: "authToken", value: token },
          { name: "_db", value: DB },
          { name: "reportName", value: "LSESTMT" },
          { name: "LeaseNo", value: selectedRow?.leaseNo },
        ];
        inputs.forEach(({ name, value }) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    }
  }
  const handleDelete = async () => {
    if (selectedRow?.leaseNo) {
      setPreviewModal(true);
    }
  }
  const handleDeleteLease = async () => {
    if (selectedRow?.leaseNo) {
      try {
        setloader(true);
        const validation = new URLSearchParams();
        validation.append("Action", "CheckLeaseDeleteValidation");
        validation.append("GroupId", selectedRow?.groupId);
        const validRes = await apiService.getApiParamater(
          "GET_UNITNO_DATA",
          `?${validation.toString()}`
        );
        let valisdlist = validRes?.data?.result?.data
        debugger
        // const leasoNolist = validRes?.data?.result?.data?.find(item => !item.Invoices );
        if (valisdlist?.Invoices === 0 && valisdlist?.Receipts === 0) {
          let body = {
            groupId: selectedRow?.groupId,
            modifiedBy: userName,
          };
          const deleteRes = await apiService.delete("DELETE_LEASE_AGRE", body);
          toast.success(`${selectedRow?.leaseNo} deleted Successfully`);
          setloader(false);
          getItems();
          setPreviewModal(false);
        } else if (valisdlist?.Invoices > 0 || valisdlist?.Receipts > 0) {
          setloader(false);
          toast.warning(
            `Invoices OR Receipts are created for this lease Aggrement (${selectedRow?.leaseNo}) Cannot be Deleted`
          );
          setPreviewModal(false);
        } else if (valisdlist.length === 0) {
          setloader(false);
          setPreviewModal(false);
          toast.warning("Please refresh the page");
        } else if (valisdlist[0]?.Invoices === 0 && valisdlist[0]?.Receipts === 0) {
          let body = {
            groupId: selectedRow?.groupId,
            modifiedBy: userName,
          };
          const deleteRes = await apiService.delete("DELETE_LEASE_AGRE", body);
          toast.success(`${selectedRow?.leaseNo} deleted Successfully`);
          setloader(false);
          getItems();
          setPreviewModal(false);
        } else if (valisdlist[0]?.Invoices > 0 || valisdlist[0]?.Receipts > 0) {
          setloader(false);
          toast.warning(
            `Invoices OR Receipts are created for this lease Aggrement (${selectedRow?.leaseNo}) Cannot be Deleted`
          );
          setPreviewModal(false);
        }
      } catch (error) {
        setloader(false);
        setPreviewModal(false);
        console.error("Error Save Data", error?.deleteRes?.data?.message);
      }
    }
  }
  const handleEye = (clickedRowData) => {
    if (clickedRowData?.leaseNo) {
      const updatedData = {
        ...clickedRowData,
        eye: !clickedRowData.eye?.active,
      };
      navigate(
        `/Property/Management/LeaseAgreement/${clickedRowData?.leaseNo}`,
        { state: updatedData }
      );
    } else if (selectedRow?.leaseNo) {
      const updatedData = { ...selectedRow, eye: !selectedRow.eye?.active };
      navigate(`/Property/Management/LeaseAgreement/${selectedRow?.leaseNo}`, {
        state: updatedData,
      });
    }
  }
  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append("PageNo", newPageNo || 1);
      params.append("PageSize", pageSize || 20);
      params.append("PropertyName", formData?.Proprty?.label || "");
      params.append("Status", formData?.Status?.label || "");
      const res = await apiService.getApiParamater(
        "GET_LEASE_AGRE",
        `?${params.toString()}`
      );

      setRowData(res?.data?.result || []);
      setPagination(res.data.paginationData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching items:", error);
      // Handle error (e.g., show error message to user)
      setLoading(false); // Set loading to false even in case of error
    }
  }
  const dateFormatter = (params) => {
    const date = moment(params.value);
    return date.format("DD-MMM-YYYY");
  }
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2)
      ? 0
      : momentDate1.isBefore(momentDate2)
        ? -1
        : 1;
  }
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      suppressMovable: true,
      width: 50,
      pinned: "left",
    },
    {
      headerName: "Status",
      field: "status",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Lease No",
      field: "leaseNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Period From",
      field: "leaseStart",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: "Period To",
      field: "leaseEnd",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: "Property",
      field: "propertyName",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: "Unit Num",
      field: "unitNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Unit Type",
      field: "unitType",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Account Code",
      field: "tenantNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: "Tenant",
      field: "tenantName",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 250,
    },
    {
      headerName: "Contact Num",
      field: "contactNo",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Year Rent",
      field: "yearRent",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Discount",
      field: "discount",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Contract Value",
      field: "total",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Rent",
      field: "rent",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "VAT",
      field: "vat",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Total",
      field: "total",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Tax",
      field: "tax",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "BedRooms",
      field: "tax1",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Area",
      field: "totalArea",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 100,
    },
    {
      headerName: "Installments",
      field: "installments",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Remarks",
      field: "remarks",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 180,
    },
    {
      headerName: "Modified",
      field: "modifiedBy",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Modified On",
      field: "modifiedOn",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
    {
      headerName: "Created By",
      field: "createdBy",
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 140,
    },
    {
      headerName: "Created on",
      field: "createdOn",
      filter: true,
      floatingfilter: true,
      valueFormatter: dateFormatter,
      comparator: dateComparator,
      suppressMovable: true,
      width: 136,
    },
  ]
  const onSelectionChanged = async (event) => {
    const selectedRows = event.api.getSelectedRows();
    setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
  }
  const clearAllRows = () => {
    dispatch(clearRows());
  }
  const handlenew = () => {
    clearAllRows();
    navigate("/Property/Management/LeaseAgreement/Create");
  }
  const handleClearFilters = () => {
    setFormData({
      Proprty: [{ label: "Select Property", value: "" }],
      Unit: [{ label: "Select Unit", value: "" }],
      LeaseNo: [{ label: "Select Lease No", value: "" }],
      Status: [{ label: "All", value: "" }],
    });
    getItems();
  }
  const handlePropertyChange = (selectedOption) => {
    setFormData({ ...formData, Proprty: selectedOption });
  }
  const handleStatusFilter = (selectedOption) => {
    if (selectedOption.label == "All") {
      handleClearFilters();
    } else {
      setFormData({ ...formData, Status: selectedOption });
    }
  }
  return (
    <div className="p-4 ">
      <div className="cost-center-section">
        <div
          className="d-flex mt-3 cursor-pointer slide-header"
          onClick={() => setFilterTab(!FilterTab)}
        >
          <div className="h6 pt-1">Search Parameters</div>
        </div>
        <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
          <div
            className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
              }`}
          >
            <div className="row">
              <div className="col-4">
                <Select
                  className="p-0"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                      color: state.isFocused ? "#000 " : "#000",
                      ":hover": {
                        backgroundColor: "#F5F5F5",
                        color: "#000 ",
                      },
                    }),
                  }}
                  value={formData.Proprty}
                  onChange={(selectedOption) =>
                    handlePropertyChange(selectedOption)
                  }
                  options={proprtyList?.map((rec) => ({
                    value: rec?.value,
                    label: rec?.text,
                  }))}
                />
              </div>
              <div className="col-4">
                <Select
                  className="p-0"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                    padding: 9,
                  })}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                      color: state.isFocused ? "#000 " : "#000",
                      ":hover": {
                        backgroundColor: "#F5F5F5",
                        color: "#000 ",
                      },
                    }),
                  }}
                  value={formData.Status}
                  options={StatusFilter}
                  onChange={handleStatusFilter}
                />
              </div>
              {/* <div className='col-4'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Unit}
                                // onChange={handleStatusFilter}
                                />
                            </div>
                            <div className='col-4'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.LeaseNo}
                                // onChange={handleStatusFilter}
                                />
                            </div> */}
              <div className="col-4 d-flex gap-1">
                <div
                  onClick={() => getItems()}
                  className="mainbtnGry flex-end gap-2 w-50"
                >
                  <FaFileCircleExclamation
                    color="#fff"
                    className="center mt-1 mx-2"
                  />
                  <div className="center">Search</div>
                </div>
                <div
                  onClick={() => handleClearFilters()}
                  className="mainbtnRed flex-end gap-2 w-50"
                >
                  <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                  <div className="center">Reset</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-4">
        {loading ? (
          <div>Loading...</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">Lease Agreement List</h5>
              <div className="d-flex justify-content-end gap-1">
                <div
                  onClick={handleEye}
                  className="mainbtnSecondary flex-end gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <FaRegEye color="#fff" className="center mt-1" />
                  <div className="center">View</div>
                </div>
                {/* {permissions?.canUpdate === true ? */}
                <div
                  onClick={handleRenew}
                  className="mainbtnSecondary flex-end gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <MdOutlineAutorenew color="#fff" className="center mt-1 " />
                  <div className="center">Renew</div>
                </div>
                <div
                  onClick={handleEdit}
                  className="mainbtnSecondary flex-end gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <GrEdit color="#fff" className="center mt-1 " />
                  <div className="center">Edit</div>
                </div>
                <div
                  onClick={handleDelete}
                  className={`reversbtn flex-end gap-2 ${!selectedRow ? "" : "disabled"
                    }`}
                  style={{ cursor: selectedRow ? "pointer" : "not-allowed" }}
                >
                  <MdOutlineDeleteOutline
                    color="#fff"
                    className="center mt-1"
                  />
                  <div className="center">Delete</div>
                </div>
                <div
                  onClick={handlePrint}
                  className={`mainbtnRed flex-end gap-2 ${!selectedRow ? "disabled" : ""
                    }`}
                  style={{ cursor: selectedRow ? "pointer" : "not-allowed" }}
                >
                  <AiOutlinePrinter color="#fff" className="center mt-1 " />
                  <div className="center">Print</div>
                </div>
                {/* {permissions?.canAdd === true ? */}
                <div className="col center">
                  <button
                    className="mainbtn "
                    type="submit"
                    onClick={() => handlenew()}
                  >
                    <IoAddSharp color="#fff" className="center mt-1" />{" "}
                    <div>Add</div>
                  </button>
                </div>
                {/* : '' */}
                {/* } */}
              </div>
            </div>
            <div className="gridshad  mt-3">
              <div className="ag-theme-quartz" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: "#F0EDF5" };
                    } else {
                      return { background: "#fff" };
                    }
                  }}
                  rowData={rowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  onSelectionChanged={onSelectionChanged}
                />
              </div>
              <Pagination
                pageSize={pageSize}
                setPageSize={setPageSize}
                pagination={pagination}
                getItems={getItems}
              />
            </div>
          </>
        )}
      </div>

      <Modal show={previewModal} size="md" onHide={() => setPreviewModal(false)}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Lease</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>Are you sure you want to delete ({selectedRow?.leaseNo})</Modal.Title>
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtnRed" onClick={() => setPreviewModal(false)}>Cancel</button>
          {loader === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleDeleteLease}>
              <div className="center">Delete</div>
            </div>
          )}
        </Modal.Footer>
      </Modal>
      <Modal show={renew} size="md" onHide={() => setRenewpopup(false)}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Rent is not fully received</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>Do you want to proceed (Yes/No) ?</Modal.Title>
        </Modal.Body>
        <Modal.Footer className='end p-3'>
          <button className="mainbtnRed" onClick={() => setRenewpopup(false)}>No</button>
          <button className='mainbtn' onClick={handleRenewshift}>Yes</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default LeaseListing;
